import { TCell, type TCellProps } from '../tcell';
import classNames from 'classnames';
import { Children, cloneElement, type FC, type HTMLAttributes, type ReactElement } from 'react';
import styles from './trow-expandable-inside.module.scss';

type TCellElement = ReactElement<TCellProps, typeof TCell>;

export type TRowExpandableInsideProps = HTMLAttributes<HTMLTableRowElement> & {
  children: TCellElement | TCellElement[];
  className?: string;
  expandedContent?: React.ReactNode;
  hasDefaultExpanded?: boolean;
  hasExpandedClassName?: boolean;
  cellCount?: number;
  isExpanded?: boolean;
  isSelected?: boolean;
  hasHover?: boolean;
};

export const TRowExpandableInside: FC<TRowExpandableInsideProps> = ({
  children,
  className,
  onClick,
  expandedContent,
  hasDefaultExpanded = true,
  hasExpandedClassName = true,
  cellCount,
  isExpanded,
  isSelected,
  hasHover,
  ...props
}) => {
  const childrenCellCount = cellCount || Children.count(children);

  return (
    <>
      <tr
        className={classNames(styles.mainRow, className, {
          [styles.hasOnClick]: !!onClick,
          [styles.mainRow_expanded]: isExpanded && hasExpandedClassName,
          [styles.selected]: isSelected,
          [styles.hover]: hasHover,
        })}
        onClick={onClick}
        {...props}
      >
        {Children.map(children, (child, index) => cloneElement(child, { index }))}
      </tr>

      {expandedContent && hasDefaultExpanded && (
        <tr
          className={classNames(styles.expandRow, {
            [styles.expandRow_visible]: isExpanded,
          })}
        >
          <td colSpan={childrenCellCount} className={styles.expandCell}>
            <div
              className={classNames(styles.expandContent, {
                [styles.selected]: isSelected,
              })}
            >
              {expandedContent}
            </div>
          </td>
        </tr>
      )}

      {expandedContent && !hasDefaultExpanded && <>{expandedContent}</>}
    </>
  );
};
